module.exports = __webpack_public_path__ + "img/126-galapagos islands.aa7dbd48.svg";